import useI18n from 'src/hooks/use_i18n'
/**
 *
 * carriers 详情页THD
 * 遵循 cms内容THK > 本地内容TDK > 模板TDK > 词条TDK
 * @returns
 */
export default function useCarrierMeta({ carriersInfoData, cmsCarrier, carrierName }) {
  const { $t, activeLocale: locale, i18nFormatAll } = useI18n()
  const title =
    i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pSeoTitleTracking'), {
      carriersName: carrierName
    }) +
    ` | ${$t('ResCarrierListPSeoDetails.global.__pSeoTitleTrackPage')}` +
    ' | ' +
    '17TRACK'
  const description = i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pSeoDesc'), {
    carriersName: carrierName
  })
  const keywords = i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pSeoKeyWords'), {
    carriersName: carrierName
  })
  //config.carriers.json对象数据
  let localTitle = ''
  let localDescription = ''
  let localKeywords = ''
  if (JSON.stringify(carriersInfoData) !== '{}') {
    localTitle =
      i18nFormatAll(
        carriersInfoData.metaInfo?.metaTitle ||
          $t('ResCarrierListPSeoDetails.global.__pSeoTitleTracking') +
            `${!['pt'].includes(locale) ? `| ${$t('ResCarrierListPSeoDetails.global.__pSeoTitleTrackPage')}` : ''}`,
        {
          carriersName: carrierName,
          '0': carrierName
        }
      ) + ' | 17TRACK'
    localDescription =
      i18nFormatAll(carriersInfoData.metaInfo?.metaDescription, {
        carriersName: carrierName
      }) || i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pSeoDesc'), { carriersName: carrierName })
    localKeywords =
      i18nFormatAll(carriersInfoData.metaInfo?.keyWords, {
        carriersName: carrierName
      }) ||
      i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pSeoKeyWords'), {
        carriersName: carrierName
      })
  }

  return {
    title:
      i18nFormatAll(cmsCarrier?.title, { carriersName: carrierName }) ||
      localTitle ||
      i18nFormatAll(cmsCarrier?.template?.title, { carriersName: carrierName }) ||
      title,
    description:
      i18nFormatAll(cmsCarrier?.description, { carriersName: carrierName }) ||
      localDescription ||
      i18nFormatAll(cmsCarrier?.template?.description, { carriersName: carrierName }) ||
      description,
    keywords:
      i18nFormatAll(cmsCarrier?.keywords, { carriersName: carrierName }) ||
      localKeywords ||
      i18nFormatAll(cmsCarrier?.template?.keywords, { carriersName: carrierName }) ||
      keywords
  }
}
